import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { put } from "sr/utils/axios";

export const updateApplication = async (putData: any) => {
  try {
    const res = await put<ApiResponse<[]>>("/application/", putData);

    return res;
  } catch (e: any) {
    console.log("updateApplication error:", e);
    console.log("error response:", e?.response);
    console.log("error data:", e?.response?.data);

    return e?.response?.data || null;
  }
};
